import { render, staticRenderFns } from "./myTrain.vue?vue&type=template&id=3d833c91&scoped=true&"
import script from "./myTrain.vue?vue&type=script&lang=ts&"
export * from "./myTrain.vue?vue&type=script&lang=ts&"
import style0 from "./myTrain.vue?vue&type=style&index=0&id=3d833c91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d833c91",
  null
  
)

export default component.exports